/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '../../assets/css/bootstrap.min.css.shim.ngstyle';
import * as import1 from '../../assets/sass/checkout.scss.shim.ngstyle';
import * as import2 from '@angular/core';
import * as import3 from '@angular/common';
import * as import4 from '../../../app/checkout/checkout-summary.component';
import * as import5 from '@angular/router';
import * as import6 from '../../../app/services/checkout.service';
const styles_CheckoutSummaryComponent:any[] = [
  import0.styles,
  import1.styles
]
;
export const RenderType_CheckoutSummaryComponent:import2.RendererType2 = import2.ɵcrt({
  encapsulation: 0,
  styles: styles_CheckoutSummaryComponent,
  data: {}
}
);
function View_CheckoutSummaryComponent_1(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'checkout-summary-box__item-price'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '\n        +',
      ' zł/mies.\n      '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.checkout.line.netto.toFixed(2).replace('.',',');
    ck(v,1,0,currVal_0);
  });
}
function View_CheckoutSummaryComponent_2(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
      (l()(),import2.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'checkout-summary-box__item-price'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n          '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),2,'s',[[
        'class',
        'text-danger'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'small',[[
        'class',
        'text-danger'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '+',
      ' zł/mies.'
    ]
    )),
    (l()(),import2.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'b',[[
        'class',
        'text-success'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '+',
      ' zł/mies.'
    ]
    )),
    (l()(),import2.ɵted((null as any),['\n      ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.checkout.line.netto.toFixed(2);
    ck(v,4,0,currVal_0);
    const currVal_1:any = co.afterPromotionValue(co.checkout.line.netto,1,(null as any),true).toFixed(2).replace('.',',');
    ck(v,7,0,currVal_1);
  });
}
function View_CheckoutSummaryComponent_9(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '\n                    ',
      ' - ',
      '',
      '\n                  '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = (<any>(<any>(<any>(<any>v.parent).parent).parent).parent).context.$implicit.name;
    const currVal_1:any = (<any>(<any>(<any>v.parent).parent).parent).context.$implicit.value;
    const currVal_2:any = (<any>(<any>(<any>v.parent).parent).parent).context.$implicit.unit;
    ck(v,1,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_CheckoutSummaryComponent_10(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '\n                    ',
      'x ',
      ' - ',
      '',
      '\n                  '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = (<any>(<any>(<any>v.parent).parent).parent).context.$implicit.selectedValue;
    const currVal_1:any = (<any>(<any>(<any>(<any>v.parent).parent).parent).parent).context.$implicit.name;
    const currVal_2:any = (<any>(<any>(<any>v.parent).parent).parent).context.$implicit.value;
    const currVal_3:any = (<any>(<any>(<any>v.parent).parent).parent).context.$implicit.unit;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3);
  });
}
function View_CheckoutSummaryComponent_11(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '\n                    ',
      ' - ',
      '',
      ' ',
      '\n                  '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = (<any>(<any>(<any>(<any>v.parent).parent).parent).parent).context.$implicit.name;
    const currVal_1:any = (<any>(<any>(<any>v.parent).parent).parent).context.$implicit.value;
    const currVal_2:any = (<any>(<any>(<any>v.parent).parent).parent).context.$implicit.unit;
    const currVal_3:any = (<any>(<any>(<any>v.parent).parent).parent).context.$implicit.selectedValue;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3);
  });
}
function View_CheckoutSummaryComponent_8(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),10,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n                  '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_9)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n                  '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_10)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n                  '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_11)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = (((<any>(<any>v.parent).parent).context.$implicit.type !== 'select') && ((<any>(<any>v.parent).parent).context.$implicit.min === (<any>(<any>v.parent).parent).context.$implicit.max));
    ck(v,3,0,currVal_0);
    const currVal_1:any = (((<any>(<any>v.parent).parent).context.$implicit.type !== 'select') && ((<any>(<any>v.parent).parent).context.$implicit.min !== (<any>(<any>v.parent).parent).context.$implicit.max));
    ck(v,6,0,currVal_1);
    const currVal_2:any = ((<any>(<any>v.parent).parent).context.$implicit.type === 'select');
    ck(v,9,0,currVal_2);
  },(null as any));
}
function View_CheckoutSummaryComponent_12(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '\n                  ',
      ' - ',
      '',
      '\n                '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = (<any>(<any>(<any>v.parent).parent).parent).context.$implicit.name;
    const currVal_1:any = (<any>(<any>v.parent).parent).context.$implicit.value;
    const currVal_2:any = (<any>(<any>v.parent).parent).context.$implicit.unit;
    ck(v,1,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_CheckoutSummaryComponent_16(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),8,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n                        '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),2,'s',[[
        'class',
        'text-danger'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'small',[[
        'class',
        'text-danger'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '+',
      ' zł/mies.'
    ]
    )),
    (l()(),import2.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'b',[[
        'class',
        'text-success'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '+',
      ' zł/mies.'
    ]
    )),
    (l()(),import2.ɵted((null as any),['\n                    ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ((<any>(<any>(<any>(<any>(<any>v.parent).parent).parent).parent).parent).context.$implicit.netto * (<any>(<any>(<any>(<any>(<any>v.parent).parent).parent).parent).parent).context.$implicit.selectedValue).toFixed(2).replace('.',',');
    ck(v,4,0,currVal_0);
    const currVal_1:any = co.afterPromotionValue((<any>(<any>(<any>(<any>(<any>v.parent).parent).parent).parent).parent).context.$implicit.netto,(<any>(<any>(<any>(<any>(<any>v.parent).parent).parent).parent).parent).context.$implicit.selectedValue,(<any>(<any>(<any>(<any>(<any>v.parent).parent).parent).parent).parent).context.$implicit.service).toFixed(2).replace('.',',');
    ck(v,7,0,currVal_1);
  });
}
function View_CheckoutSummaryComponent_17(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '+',
      ' zł/mies.'
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = ((<any>(<any>(<any>(<any>(<any>v.parent).parent).parent).parent).parent).context.$implicit.netto * (<any>(<any>(<any>(<any>(<any>v.parent).parent).parent).parent).parent).context.$implicit.selectedValue).toFixed(2).replace('.',',');
    ck(v,1,0,currVal_0);
  });
}
function View_CheckoutSummaryComponent_15(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),7,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n                    '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_16)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n                    '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_17)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n                  ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.havePromotion((<any>(<any>(<any>(<any>v.parent).parent).parent).parent).context.$implicit);
    ck(v,3,0,currVal_0);
    const currVal_1:boolean = !co.havePromotion((<any>(<any>(<any>(<any>v.parent).parent).parent).parent).context.$implicit);
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_CheckoutSummaryComponent_19(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),8,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n                          '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),2,'s',[[
        'class',
        'text-danger'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'small',[[
        'class',
        'text-danger'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '',
      ' zł/mies.'
    ]
    )),
    (l()(),import2.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'b',[[
        'class',
        'text-success'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '+',
      ' zł/mies.'
    ]
    )),
    (l()(),import2.ɵted((null as any),['\n                      ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (<any>(<any>(<any>(<any>(<any>v.parent).parent).parent).parent).parent).context.$implicit.range[(<any>(<any>(<any>(<any>(<any>v.parent).parent).parent).parent).parent).context.$implicit.selectedValue].toFixed(2).replace('.',',');
    ck(v,4,0,currVal_0);
    const currVal_1:any = co.afterPromotionValue((<any>(<any>(<any>(<any>(<any>v.parent).parent).parent).parent).parent).context.$implicit.range[(<any>(<any>(<any>(<any>(<any>v.parent).parent).parent).parent).parent).context.$implicit.selectedValue],1,(<any>(<any>(<any>(<any>(<any>v.parent).parent).parent).parent).parent).context.$implicit.service).toFixed(2).replace('.',',');
    ck(v,7,0,currVal_1);
  });
}
function View_CheckoutSummaryComponent_20(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '',
      ' zł/mies.'
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = (<any>(<any>(<any>(<any>(<any>v.parent).parent).parent).parent).parent).context.$implicit.range[(<any>(<any>(<any>(<any>(<any>v.parent).parent).parent).parent).parent).context.$implicit.selectedValue].toFixed(2).replace('.',',');
    ck(v,1,0,currVal_0);
  });
}
function View_CheckoutSummaryComponent_18(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),7,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n                      '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_19)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n                      '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_20)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n                  ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.havePromotion((<any>(<any>(<any>(<any>v.parent).parent).parent).parent).context.$implicit);
    ck(v,3,0,currVal_0);
    const currVal_1:boolean = !co.havePromotion((<any>(<any>(<any>(<any>v.parent).parent).parent).parent).context.$implicit);
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_CheckoutSummaryComponent_14(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),7,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n                  '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_15)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n                  '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_18)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = ((<any>(<any>(<any>v.parent).parent).parent).context.$implicit.type !== 'select');
    ck(v,3,0,currVal_0);
    const currVal_1:any = ((<any>(<any>(<any>v.parent).parent).parent).context.$implicit.type === 'select');
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_CheckoutSummaryComponent_22(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),8,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n                      '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),2,'s',[[
        'class',
        'text-danger'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'small',[[
        'class',
        'text-danger'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '',
      ' zł/mies.'
    ]
    )),
    (l()(),import2.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'b',[[
        'class',
        'text-success'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '+',
      ' zł/mies.'
    ]
    )),
    (l()(),import2.ɵted((null as any),['\n                  ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (<any>(<any>(<any>(<any>v.parent).parent).parent).parent).context.$implicit.netto.toFixed(2);
    ck(v,4,0,currVal_0);
    const currVal_1:any = co.afterPromotionValue((<any>(<any>(<any>(<any>v.parent).parent).parent).parent).context.$implicit.netto,1,(<any>(<any>(<any>(<any>v.parent).parent).parent).parent).context.$implicit.service).toFixed(2).replace('.',',');
    ck(v,7,0,currVal_1);
  });
}
function View_CheckoutSummaryComponent_23(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '+',
      ' zł/mies.'
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = (<any>(<any>(<any>(<any>v.parent).parent).parent).parent).context.$implicit.netto.toFixed(2).replace('.',',');
    ck(v,1,0,currVal_0);
  });
}
function View_CheckoutSummaryComponent_21(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),7,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n                  '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_22)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n                  '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_23)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.havePromotion((<any>(<any>(<any>v.parent).parent).parent).context.$implicit);
    ck(v,3,0,currVal_0);
    const currVal_1:boolean = !co.havePromotion((<any>(<any>(<any>v.parent).parent).parent).context.$implicit);
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_CheckoutSummaryComponent_13(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
      (l()(),import2.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'checkout-summary-box__item-price'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n                '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_14)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n                '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_21)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n              ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = (<any>(<any>v.parent).parent).context.$implicit.hasOwnProperty('selectedValue');
    ck(v,3,0,currVal_0);
    const currVal_1:boolean = (!(<any>(<any>v.parent).parent).context.$implicit.hasOwnProperty('selectedValue') && ((<any>(<any>v.parent).parent).context.$implicit.type !== 'select'));
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_CheckoutSummaryComponent_7(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
      (l()(),import2.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'checkout-summary-box__item'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n              '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'checkout-summary-box__item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n                '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_8)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n                '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_12)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n              '])),
    (l()(),import2.ɵted((null as any),['\n              '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_13)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = ((<any>v.parent).context.$implicit.hasOwnProperty('selectedValue') && ((<any>v.parent).context.$implicit.selectedValue != 1));
    ck(v,5,0,currVal_0);
    const currVal_1:boolean = (!(<any>v.parent).context.$implicit.hasOwnProperty('selectedValue') || ((<any>v.parent).context.$implicit.selectedValue == 1));
    ck(v,8,0,currVal_1);
    const currVal_2:any = (<any>v.parent).context.$implicit.checked;
    ck(v,12,0,currVal_2);
  },(null as any));
}
function View_CheckoutSummaryComponent_6(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n            '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_7)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n          ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = v.context.$implicit.checked;
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_CheckoutSummaryComponent_5(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),7,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n        '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'checkout-summary-box__item-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n          '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_6)),
    import2.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import2.ViewContainerRef,
      import2.TemplateRef,
      import2.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n        '])),
    (l()(),import2.ɵted((null as any),['\n      ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = v.context.$implicit.options;
    ck(v,5,0,currVal_0);
  },(null as any));
}
function View_CheckoutSummaryComponent_4(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
      (l()(),import2.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'checkout-summary-box__position'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n      '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'h4',[[
        'class',
        'checkout-summary-box__position-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import2.ɵted((null as any),['\n      '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_5)),
    import2.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import2.ViewContainerRef,
      import2.TemplateRef,
      import2.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    const currVal_1:any = (<any>v.parent).context.$implicit.subgroups;
    ck(v,6,0,currVal_1);
  },(ck,v) => {
    const currVal_0:any = (<any>v.parent).context.$implicit.name;
    ck(v,3,0,currVal_0);
  });
}
function View_CheckoutSummaryComponent_3(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n    '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_4)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n  ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.isAnySubgroupActive(v.context.$implicit);
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_CheckoutSummaryComponent_24(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
      (l()(),import2.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'checkout-summary-box__item'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n      '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'checkout-summary-box__item-name checkout-summary-box__brutto'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n        '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'text-success'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['Łączna kwota rabatu'])),
    (l()(),import2.ɵted((null as any),['\n      '])),
    (l()(),import2.ɵted((null as any),['\n      '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'checkout-summary-box__item-price'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n        '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'text-success'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '-',
      ''
    ]
    )),
    (l()(),import2.ɵted((null as any),['\n      '])),
    (l()(),import2.ɵted((null as any),['\n    ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.getTotalDiscountValue().replace('.',',');
    ck(v,11,0,currVal_0);
  });
}
function View_CheckoutSummaryComponent_25(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
      (l()(),import2.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'checkout-summary-box__item'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n        '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'checkout-summary-box__item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n          Razem po rabacie\n        '])),
    (l()(),import2.ɵted((null as any),['\n        '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'checkout-summary-box__item-price'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n            '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'text-success'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import2.ɵted((null as any),['\n        '])),
    (l()(),import2.ɵted((null as any),['\n      ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.getTotalAmount().toFixed(2).replace('.',',');
    ck(v,8,0,currVal_0);
  });
}
function View_CheckoutSummaryComponent_26(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'a',[[
        'class',
        'orange-button full-size'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.goToCompanySelect()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n      Uzupełnij dane\n    ']))
  ]
  ,(null as any),(null as any));
}
export function View_CheckoutSummaryComponent_0(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    import2.ɵpid(0,import3.UpperCasePipe,([] as any[])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),78,'div',[[
        'class',
        'checkout-summary-box'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n  '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'h3',[[
        'class',
        'checkout-summary-box__title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['Podsumowanie zamówienia'])),
    (l()(),import2.ɵted((null as any),['\n\n  '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),17,'div',[[
        'class',
        'checkout-summary-box__position'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n    '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'h4',[[
        'class',
        'checkout-summary-box__position-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['Konfiguracja'])),
    (l()(),import2.ɵted((null as any),['\n    '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'checkout-summary-box__item'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n      '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'checkout-summary-box__item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '\n        ',
      '\n      '
    ]
    )),
    import2.ɵppd(1),
    (l()(),import2.ɵted((null as any),['\n      '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_1)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n      '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_2)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n    '])),
    (l()(),import2.ɵted((null as any),['\n  '])),
    (l()(),import2.ɵted((null as any),['\n\n  '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_3)),
    import2.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import2.ViewContainerRef,
      import2.TemplateRef,
      import2.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n\n  '])),
    (l()(),import2.ɵeld(0,(null as any),(null as any),0,'hr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n\n  '])),
    (l()(),import2.ɵeld(0,(null as any),(null as any),34,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n    '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'checkout-summary-box__item'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n      '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'checkout-summary-box__item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n        Razem\n      '])),
    (l()(),import2.ɵted((null as any),['\n      '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'checkout-summary-box__item-price'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '\n        ',
      '\n      '
    ]
    )),
    (l()(),import2.ɵted((null as any),['\n    '])),
    (l()(),import2.ɵted((null as any),['\n\n    '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_24)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n\n    '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_25)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n\n    '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'checkout-summary-box__item'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n      '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'checkout-summary-box__item-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n        VAT\n      '])),
    (l()(),import2.ɵted((null as any),['\n      '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'checkout-summary-box__item-price'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '\n        ',
      '\n      '
    ]
    )),
    (l()(),import2.ɵted((null as any),['\n    '])),
    (l()(),import2.ɵted((null as any),['\n\n    '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'checkout-summary-box__item'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n      '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'checkout-summary-box__item-name checkout-summary-box__brutto'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n        Kwota brutto do zapłaty\n      '])),
    (l()(),import2.ɵted((null as any),['\n      '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'checkout-summary-box__item-price'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '\n        ',
      '\n      '
    ]
    )),
    (l()(),import2.ɵted((null as any),['\n    '])),
    (l()(),import2.ɵted((null as any),['\n  '])),
    (l()(),import2.ɵted((null as any),['\n\n  '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'checkout-summary-box__total-box'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n    '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'checkout-summary-box__total-box-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['Opłata miesięczna'])),
    (l()(),import2.ɵted((null as any),['\n    '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'checkout-summary-box__total-box-price'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),[
      '',
      ' zł\n    '
    ]
    )),
    (l()(),import2.ɵted((null as any),['\n    '])),
      (l()(),import2.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'checkout-summary-box__total-box-agreement'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import2.ɵted((null as any),['\n    '])),
    (l()(),import2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CheckoutSummaryComponent_26)),
    import2.ɵdid(16384,(null as any),0,import3.NgIf,[
      import2.ViewContainerRef,
      import2.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import2.ɵted((null as any),['\n  '])),
    (l()(),import2.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import4.CheckoutSummaryComponent = v.component;
    const currVal_1:boolean = !co.haveServerPromotion();
    ck(v,18,0,currVal_1);
    const currVal_2:any = co.haveServerPromotion();
    ck(v,21,0,currVal_2);
    const currVal_3:any = co.checkout.line.groups;
    ck(v,26,0,currVal_3);
    const currVal_5:any = co.getTotalDiscountValue();
    ck(v,42,0,currVal_5);
    const currVal_6:any = co.getTotalDiscountValue();
    ck(v,45,0,currVal_6);
    const currVal_11:any = co.fillData;
    ck(v,77,0,currVal_11);
  },(ck,v) => {
    var co:import4.CheckoutSummaryComponent = v.component;
    const currVal_0:any = import2.ɵunv(v,14,0,ck(v,15,0,import2.ɵnov(v,0),co.checkout.line.name));
    ck(v,14,0,currVal_0);
    const currVal_4:any = co.getTotalAmount(true).toFixed(2).replace('.',',');
    ck(v,38,0,currVal_4);
    const currVal_7:any = (co.getTotalAmount() * 0.23).toFixed(2).replace('.',',');
    ck(v,53,0,currVal_7);
    const currVal_8:any = (co.getTotalAmount() + (co.getTotalAmount() * 0.23)).toFixed(2).replace('.',',');
    ck(v,62,0,currVal_8);
    const currVal_9:any = (co.getTotalAmount() + (co.getTotalAmount() * 0.23)).toFixed(2).replace('.',',');
    ck(v,72,0,currVal_9);
    const currVal_10:any = co.getAgreement();
    ck(v,74,0,currVal_10);
  });
}
function View_CheckoutSummaryComponent_Host_0(l:any):import2.ɵViewDefinition {
  return import2.ɵvid(0,[
    (l()(),import2.ɵeld(0,(null as any),(null as any),1,'checkout-summary-component',([] as any[]),(null as any),(null as any),(null as any),View_CheckoutSummaryComponent_0,RenderType_CheckoutSummaryComponent)),
    import2.ɵdid(49152,(null as any),0,import4.CheckoutSummaryComponent,[
      import5.Router,
      import6.CheckoutService
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const CheckoutSummaryComponentNgFactory:import2.ComponentFactory<import4.CheckoutSummaryComponent> = import2.ɵccf('checkout-summary-component',import4.CheckoutSummaryComponent,View_CheckoutSummaryComponent_Host_0,{
  checkout: 'checkout',
  fillData: 'fillData',
  validCodes: 'validCodes'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/checkout/checkout-summary.component.ngfactory.ts